<template>
  <div style="position: relative">
    <div v-if="loading" class="progress-bar">
      <div class="progress-bar-value"></div>
    </div>
    <div v-if="loading" class="loading-overlay"></div>
    <div class="d-flex justify-content-between align-items-center">
      <h3><feather-icon size="22" icon="CalendarIcon" /> برامج المنظمة</h3>
      <b-button
        v-if="canAddTransaction"
        @click="newProgramModal = true"
        variant="success"
        v-can="{ slug: $route.meta.slug, action: 'C' }"
      >
        <feather-icon size="15" class="mr-25" icon="PlusIcon" />
        إضافة برنامج
      </b-button>
    </div>
    <hr />
    <app-collapse v-can="{ slug: $route.meta.slug, action: 'S' }">
      <program-collapse
        v-for="program in programs"
        :key="program.id"
        :title="program.name"
        @editClicked="openEditProgramModal(program)"
        @deleteClicked="onDeleteProgram(program)"
      >
        <b-container>
          <b-row class="justify-content-start">
            <b-col cols="12">
              <h4 class="">
                <feather-icon
                  class="align-middle"
                  size="20"
                  icon="FileTextIcon"
                />
                المعلومات الأساسية
              </h4>
            </b-col>

            <b-col lg="6" sm="12" v-for="(item, key) in mainInfo" :key="key">
              <info-card
                :label="item.label"
                :value="
                  key === 'categories'
                    ? program[key].map((el) => el.name_ar).join(' , ')
                    : key === 'services'
                    ? program[key].map((el) => el.name_ar).join(' , ')
                    : program[key]
                "
              />
            </b-col>
          </b-row>
        </b-container>
      </program-collapse>
    </app-collapse>
    <pagination
      @input="currentPage = $event"
      :total-rows="pagination.total_row"
      :per-page="pagination.per_page"
      :value="parseInt(pagination.current_page)"
      align="end"
    >
    </pagination>

    <program-modal
      @confirm="onNewProgram"
      :loading="working"
      v-model="newProgramModal"
    />
    <program-modal
      @confirm="onUpdateProgram"
      :loading="working"
      ref="editProgramModal"
      v-model="editProgramModal"
      :intializeForm.sync="editProgramForm"
    />
  </div>
</template>

<script>
import {
  BButton,
  BContainer,
  BCol,
  BRow,
  BFormInput,
  BFormGroup,
  BDropdown,
  BDropdownItem,
} from "bootstrap-vue";
import InfoCard from "@/components/InfoCard.vue";
import dataTable from "@/components/data-table";
import AppCollapseItem from "@core/components/app-collapse/AppCollapseItem.vue";
import AppCollapse from "@core/components/app-collapse/AppCollapse.vue";
import ProgramCollapse from "../../components/ProgramCollapse";
import ProgramModal from "../../components/ProgramModal.vue";
import editSidebar from "../../components/SideBar.vue";
import { mapActions, mapGetters } from "vuex";
import Pagination from "@/components/pagination";
export default {
  components: {
    BButton,
    BContainer,
    BCol,
    BRow,
    InfoCard,
    AppCollapseItem,
    AppCollapse,
    ProgramCollapse,
    ProgramModal,
    dataTable,
    editSidebar,
    BFormInput,
    BFormGroup,
    BDropdown,
    BDropdownItem,
    Pagination,
  },
  data() {
    return {
      editProgramForm: {},
      editProgramModal: false,
      newProgramModal: false,
      currentPage: 1,

      mainInfo: {
        name: {
          label: "الاسم",
        },
        objectives: {
          label: " الأهداف",
        },
      },
    };
  },
  methods: {
    ...mapActions("ProgramsAndActivities/Programs", [
      "getPrograms",
      "addProgram",
      "editProgram",
      "deleteProgram",
    ]),
    async onNewProgram(payload) {
      await this.addProgram(payload);
      this.newProgramModal = false;
    },
    async onUpdateProgram(payload) {
      await this.editProgram(payload);
      this.editProgramModal = false;
    },
    onDeleteProgram(id) {
      this.$bvModal
        .msgBoxConfirm("هل أنت متأكد من حذف البرنامج", {
          title: "تأكيد حذف البرنامج",
          size: "sm",
          okVariant: "danger",
          okTitle: "تأكيد",
          cancelTitle: "إلغاء",
          cancelVariant: "outline-secondary",
          hideHeaderClose: false,
          centered: true,
        })
        .then((value) => {
          if (value) this.deleteProgram(id);
        });
    },
    openEditProgramModal(program) {
      this.editProgramForm = JSON.parse(
        JSON.stringify({
          id: program.id,
          name: program.name,
          program_type: program.program_type,
          start_date: program.start_date,
          end_date: program.end_date,
          objectives: program.objectives,
          ngo_id: program.ngo_id,
          service_ids: program.services.map((el) => el.id),
          category_ids: program.categories.map((el) => el.id),
        })
      );
      this.$refs.editProgramModal.init(this.editProgramForm);
      this.editProgramModal = true;
    },
  },
  computed: {
    ...mapGetters("ProgramsAndActivities/Programs", [
      "programs",
      "loading",
      "working",
      "pagination",
    ]),
    
    ...mapGetters("NgoProfile", [ "canAddTransaction"]),
  },
  watch: {
    currentPage(val) {
      this.getPrograms({ page: val });
    },
  },
  created() {
    this.getPrograms({ page: this.currentPage });
  },
  mounted() {
    this.mainInfo = {
      name: {
        label: "الاسم",
      },
      objectives: {
        label: " الأهداف",
      },
      categories: {
        label: "الفئات المستهدفة",
      },
      services: {
        label: " الخدمات",
      },
    };
  },
};
</script>

<style lang="scss">
.info-card {
  border: 1px solid #f2f2f2;
  border-radius: 7px;
}
</style>
